import React from "react";
import { SearchTypeEnum, ISearchValue } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import { useIntervalModel } from "../intervalModel";
import { useGlobalModel } from "@/model/globalModel";

export function PageHeader() {
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData,
    } = useIntervalModel();
    const { fetchWarehouseList, shopDs } = useGlobalModel();
    const searchFields = [
        {
            type: SearchTypeEnum.Select,
            placeholder: "从属门店",
            fieldName: "shopCode",
            options: shopDs.map(item => ({ ...item, value: item.code }))
        },
        {
            type: SearchTypeEnum.AsyncSelect,
            placeholder: "仓库",
            fieldName: "warehouseCode",
            selectfetchList: fetchWarehouseList,
        }
    ]

    return (
        <YhPageHeader
            title="区间库存变动"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    );
}